import { BaseProfile, IProfile } from "./profiles";
import { UserSource } from "./source";
import { getUser } from "./index";
import { SIMSARI_USER } from "./roles";

export interface ISimsariProfile extends IProfile {
	Name: string;
	DeveloperId: number;
	AcceptedTNC?: boolean;
	EmailAddress: string;
	PhoneNumber: string;
	NationalityId: number;
	ProfileId: number;
	OwnerId: number;
	BrokerId: number;
	UserName: string;
	AllowedFeatures: number[];
}

export class SimsariProfile extends BaseProfile implements ISimsariProfile {
	Name: string;
	DeveloperId: number;
	AcceptedTNC?: boolean;
	EmailAddress: string;
	PhoneNumber: string;
	NationalityId: number;
	ProfileId: number;
	OwnerId: number;
	BrokerId: number;
	UserName: string;
	AllowedFeatures: number[];

	constructor( profile: ISimsariProfile ) {
		super( UserSource.SIMSARI, profile.ProfileId );
		this.refreshRoles();
		this.Name = profile.Name;
		this.DeveloperId = profile.DeveloperId;
		this.AcceptedTNC = profile.AcceptedTNC;
		this.EmailAddress = profile.EmailAddress;
		this.PhoneNumber = profile.PhoneNumber;
		this.NationalityId = profile.NationalityId;
		this.ProfileId = profile.ProfileId;
		this.OwnerId = profile.OwnerId;
		this.BrokerId = profile.BrokerId;
		this.UserName = profile.UserName;
		this.AllowedFeatures = profile.AllowedFeatures;
	}

	static buildProfile( profile: ISimsariProfile ) {
		const p = new SimsariProfile( profile );
		return p;
	}

	static getProfile(): ISimsariProfile | undefined {
		const u = getUser();
		if ( u ) return u.getProfile( UserSource.SIMSARI ) as ISimsariProfile;
		return undefined;
	}

	static getSimSariOwnerId(): number | undefined {
		const p = SimsariProfile.getProfile();
		if ( p ) return p.OwnerId;
		return undefined;
	}

	static getSimSariProfileID(): number | undefined {
		const p = SimsariProfile.getProfile();
		if ( p ) return p.ProfileId;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( SIMSARI_USER ) ) this.addRole( SIMSARI_USER );
	}
}
